module.exports = __webpack_public_path__ + "static/media/back-img.6262f478.svg";